<template>
	<a href="#" aria-role="button" v-bind:tabindex="tabindex || 0" v-on:click.stop.prevent="toDownloadCenter" v-text="$t('go_to_download_center')" v-bind:class="['button', 'downloads', 'go-to', 'has-icon', 'icon-right']"></a>
</template>

<script>
export default {
	props: ['tabindex'],
	methods: {
		toDownloadCenter() {
			var lang = this.$store.state.lang;
			this.$router.push({
				name: lang + '-downloads',
				params: {
					lang
				}
			})
		}
	}
}
</script>